<template>
<v-layout column justify-center align-center>
  <v-tooltip bottom v-if="charger">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" :color="chargerColor" :dark="chargerDark" small>
        <v-avatar left :class="[chargerColor, 'darken-4']">
          <v-icon v-if="isOnline">ev_station</v-icon>
          <v-icon v-else>ev_station</v-icon>
        </v-avatar>
        <v-icon v-if="!isOnline && hasPlug">power_off</v-icon>
        {{ $_getSimpleDate(latestUpdatedTime) }}
      </v-chip>
    </template>
    <span>충전기 : {{ charger.managementNumber }}</span><br>
    <span v-if="hasPlug">플러그 : {{ plug.id }}</span>
    <template>
      <br>
      <span>상태 확인 시각 : {{ $_getFullDate(latestUpdatedTime) }} </span><br>
      <span>상태 확인 코드 : {{ chargerPlugStatus }} </span><br>
      <span>온라인 : {{ isOnline }} </span><br>
      <span>충전중 : {{ isOnCharging }} </span><br>
    </template>
  </v-tooltip>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-badge color="red" overlap>
          <template v-slot:badge v-if="chargingReports.length > 0">
            <span>{{ chargingReports.length }}</span>
          </template>
          <v-chip small>
            <v-avatar left class="darken-4">
              <v-icon>battery_charging_full</v-icon>
            </v-avatar>
            <!--{{ $_getSimpleDate($_latestChargingTime()) }}-->
            {{ getWh }}
          </v-chip>
        </v-badge>
      </div>
    </template>
    <template>
      <span>최근 충전 시각 : {{ $_getFullDate(latestChargingTime) }} </span><br>
      <span>충전 회수 : {{ chargingReports.length }} 건</span><br>
      <span>충전 시간 : {{ totalChargingTime }} 분 ({{ averageChargingTime }} 분 / 건)</span><br>
      <span>충전량 : {{ totalChargingValue }} Wh ({{ averageChargingValue }} Wh / 건)</span><br>
      <br>
      <span v-for="report in chargingReportsForTooltip" :key="report.id">
        {{report.serialNumber}} : {{ $_getFullDate(report.created.toDate()) }}  -  {{ $_getChargingValue(report) + ' Wh' }}<br>
      </span>
    </template>
  </v-tooltip>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-badge color="red" overlap>
          <template v-slot:badge v-if="checkReports.length > 0">
            <span>{{ checkReports.length }}</span>
          </template>
          <v-chip :color="reportColor" :dark="reportDark" small>
            <v-avatar left :class="[reportColor, 'darken-4']">
              <v-icon>assignment</v-icon>
            </v-avatar>
            {{ $_getSimpleDate(latestCheckingTime) }}
          </v-chip>
        </v-badge>
      </div>
    </template>
    <template>
      <span>최근 점검 시각 : {{ $_getFullDate(latestCheckingTime) }} </span><br>
      <br>
      <span v-for="report in checkReportsForTooltip" :key="report.id">
        {{ $_getFullDate(report.created.toDate()) }} - {{ report.checkResult ? '정상' : '오류' }}<br>
      </span>
    </template>
  </v-tooltip>
</v-layout>
</template>

<script>
// import firebase from 'firebase/compat/app'
// import 'firebase/compat/firestore'
import {Util} from '../Util'
import moment from 'moment'

export default {
  name: 'ChargerStatusItem',
  // props: ['charger'],
  props: {charger: {},
    checkReports: {
      type: Array,
      default () {
        return []
      }
    },
    plug: {},
    chargingReports: {
      type: Array,
      default () {
        return []
      }
    },
    plugStatus: {}
  },
  computed: { // 캐싱됨, prop, data 에 관련된 종속성은 하나만 되게 할 것.
    chargerColor () {
      if (this.isOnline) {
        return 'primary'
      } else {
        return (this.plugStatus) ? 'warning' : ''
      }
    },
    chargerDark () {
      if (this.plugStatus) {
        return this.plugStatus.online
      }

      return false
    },
    reportColor () {
      if (this.checkReports.length > 0 && !this.latestChargerReportCheckResult) {
        return 'warning'
      }
    },
    reportDark () {
      if (this.checkReports.length > 0 && !this.latestChargerReportCheckResult) {
        return true
      } else {
        return false
      }
    },
    hasPlug () {
      return this.plug && this.plug.id
    },
    checkReportsForTooltip () {
      if (this.checkReports && this.checkReports.length > 0) {
        const newArr = Array.from(this.checkReports)
        return newArr.reverse().slice(0, 10)
      }
      return this.checkReports
    },
    chargingReportsForTooltip () {
      if (this.chargingReports && this.chargingReports.length > 0) {
        const newArr = Array.from(this.chargingReports)
        return newArr.reverse().slice(0, 10)
      }
      return this.chargingReports
    },
    getWh () {
      if (this.chargingReports.length > 0) {
        return (this.totalChargingValue / 1000).toFixed(2) + 'kWh'
      }
    },
    isOnline () {
      return Util.Plug.isOnline(this.plug, this.plugStatus)
    },
    isOnCharging () {
      return Util.Plug.isOnCharging(this.plug, this.plugStatus)
    },
    totalChargingTime () {
      let totalChargingTime = 0

      this.chargingReports.forEach(report => {
        totalChargingTime += report.duration
      })

      return totalChargingTime
    },
    averageChargingTime () {
      return Math.round(this.totalChargingTime / this.chargingReports.length)
    },
    totalChargingValue () {
      let totalChargingValue = 0

      this.chargingReports.forEach(report => {
        report.values.forEach(value => {
          if (!isNaN(value)) {
            totalChargingValue += value
          }
        })
      })

      return totalChargingValue
    },
    averageChargingValue () {
      return Math.round(this.totalChargingValue / this.chargingReports.length)
    },
    latestChargingTime () {
      let latestChargingTime = 0

      this.chargingReports.forEach(report => {
        let chargingTime = report.updated || report.created

        if (chargingTime.toDate() > latestChargingTime) {
          latestChargingTime = chargingTime.toDate()
        }
      })

      return latestChargingTime
    },
    latestCheckingTime () {
      let latestCheckingTime = 0

      this.checkReports.forEach(report => {
        let reportingTime = report.updated || report.created

        if (reportingTime.toDate() > latestCheckingTime) {
          latestCheckingTime = reportingTime.toDate()
        }
      })

      return latestCheckingTime
    },
    latestUpdatedTime () {
      if (this.hasPlug) {
        let updatedTime = this.plugStatus ? this.plugStatus.updated : (this.plug.updated || this.plug.created)
        // console.log(updatedTime, this.plug.status ? this.plug.status.updated : this.plug.created)

        return updatedTime.toDate()
      }

      return 0
    },
    latestChargerReportCheckResult () {
      let latestChargerReportingTime = 0
      let checkResult = false

      this.checkReports.forEach(report => {
        let reportingTime = report.updated || report.created

        if (reportingTime.toDate() > latestChargerReportingTime) {
          latestChargerReportingTime = reportingTime.toDate()
          checkResult = report.checkResult
        }
      })

      return checkResult
    },
    chargerPlugStatus () {
      return this.plugStatus ? (this.plugStatus ? this.plugStatus.reason.cmd : '') : ''
    }
  },
  created () {
    // console.log('created', this.plug, this.charger)
  },
  updated () {
    // console.log('updated', this.plug, this.charger)
  },
  methods: {
    $_getSimpleDate (date) {
      if (date === 0) {
        return ''
      }

      if (!moment().isSame(date, 'year')) {
        return moment(date).format('YYYY-MM')
      } else if (!moment().isSame(date, 'month') || !moment().isSame(date, 'day')) {
        return moment(date).format('MM-DD')
      } else {
        return moment(date).format('HH:mm')
      }
    },
    $_getFullDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    $_getChargingValue (report) {
      let totalChargingValue = 0
      report.values.forEach(value => {
        totalChargingValue += value
      })

      return totalChargingValue
    }
    /*
    $_getWh () {
      if (this.chargingReports.length > 0) {
        return (this.$_totalChargingValue() / 1000).toFixed(2) + 'kWh'
      }
    },
    $_isOnline () {
      return Util.Plug.isOnline(this.plug, this.plugStatus)
    },
    $_isOnCharging () {
      return Util.Plug.isOnCharging(this.plug, this.plugStatus)
    },
    $_totalChargingTime () {
      let totalChargingTime = 0

      this.chargingReports.forEach(report => {
        totalChargingTime += report.duration
      })

      return totalChargingTime
    },
    $_averageChargingTime () {
      return Math.round(this.$_totalChargingTime() / this.chargingReports.length)
    },
    $_totalChargingValue () {
      let totalChargingValue = 0

      this.chargingReports.forEach(report => {
        report.values.forEach(value => {
          if (!isNaN(value)) {
            totalChargingValue += value
          }
        })
      })

      return totalChargingValue
    },
    $_averageChargingValue () {
      return Math.round(this.$_totalChargingValue() / this.chargingReports.length)
    },
    $_latestChargingTime () {
      let latestChargingTime = 0

      this.chargingReports.forEach(report => {
        let chargingTime = report.updated || report.created

        if (chargingTime.toDate() > latestChargingTime) {
          latestChargingTime = chargingTime.toDate()
        }
      })

      return latestChargingTime
    },
    $_latestCheckingTime () {
      let latestCheckingTime = 0

      this.checkReports.forEach(report => {
        let reportingTime = report.updated || report.created

        if (reportingTime.toDate() > latestCheckingTime) {
          latestCheckingTime = reportingTime.toDate()
        }
      })

      return latestCheckingTime
    },
    $_latestUpdatedTime () {
      if (this.hasPlug) {
        let updatedTime = this.plugStatus ? this.plugStatus.updated : (this.plug.updated || this.plug.created)
        // console.log(updatedTime, this.plug.status ? this.plug.status.updated : this.plug.created)

        return updatedTime.toDate()
      }

      return 0
    },
    $_latestChargerReportCheckResult () {
      let latestChargerReportingTime = 0
      let checkResult = false

      this.checkReports.forEach(report => {
        let reportingTime = report.updated || report.created

        if (reportingTime.toDate() > latestChargerReportingTime) {
          latestChargerReportingTime = reportingTime.toDate()
          checkResult = report.checkResult
        }
      })

      return checkResult
    },
    $_chargerPlugStatus () {
      return this.plugStatus ? (this.plugStatus ? this.plugStatus.reason.cmd : '') : ''
    }
    */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-chip {
  width: 90px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Charger/ChargerStatusItem.vue